import React, { useState } from 'react'
import { Button } from 'primereact/button'
import ContactSearchModal from './ContactSearchModal'

const ContactSearchPoc = () => {
    const [modalVisible, setModalVisible] = useState(false)
    const [selectedContributor, setSelectedContributor] = useState(null)

    const handleOpenModal = () => {
        setModalVisible(true)
    }

    const handleCloseModal = () => {
        setModalVisible(false)
    }

    const handleConfirmContributor = (contributor) => {
        setSelectedContributor(contributor)
        setModalVisible(false)
    }

    return (
        <div className="contact-search-poc p-4">
            <div className="mb-4">
                <h1>Contact Search - Proof of Concept</h1>
                <p className="text-color-secondary">
                    This is a demonstration of the Contact Search modal for adding contributors to episodes.
                </p>
            </div>

            <div className="mb-4">
                <Button
                    label="Add New Contributor"
                    icon="pi pi-plus"
                    onClick={handleOpenModal}
                    className="p-button-primary"
                />
            </div>

            {selectedContributor && (
                <div className="mt-4 p-3 surface-card border-round">
                    <h3>Selected Contributor</h3>
                    <div className="grid">
                        <div className="col-3">
                            <strong>Code:</strong> {selectedContributor.contact?.code}
                        </div>
                        <div className="col-3">
                            <strong>Author Key:</strong> {selectedContributor.contact?.authorKey}
                        </div>
                        <div className="col-3">
                            <strong>Name:</strong> {selectedContributor.name?.name}
                        </div>
                        <div className="col-3">
                            <strong>Membership:</strong> {selectedContributor.membership?.type}
                        </div>
                    </div>
                </div>
            )}

            <ContactSearchModal
                visible={modalVisible}
                onHide={handleCloseModal}
                onConfirm={handleConfirmContributor}
            />
        </div>
    )
}

export default ContactSearchPoc
